export default __webpack_public_path__ + "static/media/Twitter_White.ee401024.svg";